import { render, staticRenderFns } from "./Specialties.vue?vue&type=template&id=195c32bd&scoped=true&"
import script from "./Specialties.vue?vue&type=script&lang=js&"
export * from "./Specialties.vue?vue&type=script&lang=js&"
import style0 from "./Specialties.vue?vue&type=style&index=0&id=195c32bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195c32bd",
  null
  
)

export default component.exports